module.exports = __webpack_public_path__ + "img/face-lying.1100a57c.svg";